import { compose } from '@reduxjs/toolkit';
import { Col, Flex, Image, Pagination, Row, Skeleton, Tag } from 'antd';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ThumbnailImg from '../../asset/ninja_thumbnail.jpg';
import NoData from '../../asset/no-data-found.png';
import { NJVCard } from '../../components/core-component';
import { BackTitleCompo } from '../../components/general-component';
import { Constant } from '../../core/constant';
import Api from '../../network/api';
import { HTTP_METHOD } from '../../network/httpMethod';
import { MEDIA_TYPE } from '../../network/mediaType';
import { ApiHandler } from '../../network/network-manager';
import withRouter from '../../network/with-router';
import CustomPath from '../../routes/custom-path';

class ShopTypePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            shopType: this.props.location?.state?.shopType || null,
            shops: this.props.location?.state?.shops || null,
            isFetchingData: false,
            shopData: [],
            page: 0,
            pageSize: Constant.pageSize
        }
    }

    componentDidMount() {
        if (this.state.shops) {
            this.fetchPopularShops()
        }
        this.fetchShopByType();
    }

    fetchShopByType = async (pageNumber) => {
        const { shopType, page, pageSize } = this.state

        this.setState({
            isFetchingData: true,
        })
        const requestParams = {
            page: pageNumber ? pageNumber - 1 : page,
            size: pageSize,
            shopType: shopType?.value,
        }
        await ApiHandler({ url: Api.loyalty_shop_category, method: HTTP_METHOD.GET, mediaType: MEDIA_TYPE.JSON, requestParams })
            .then(response => {
                this.setState({
                    shopData: response,
                    page: pageNumber ? pageNumber : page,
                    totalElement: response.totalElements,
                })
            }).catch(err => { })
            .finally(() => {
                this.setState({
                    isFetchingData: false
                })
            })
    }

    fetchPopularShops = async (pageNumber) => {
        const { page, pageSize } = this.state
        this.setState({
            isFetchingPopularShops: true
        })
        const requestParams = {
            page: pageNumber ? pageNumber - 1 : page,
            size: pageSize
        }
        await ApiHandler({ url: Api.popular_shops, method: HTTP_METHOD.GET, mediaType: MEDIA_TYPE.JSON, requestParams })
            .then((response) => {
                this.setState({
                    popularShops: response,
                    page: pageNumber ? pageNumber : page,
                    totalElement: response.totalElements,
                })
            })
            .catch((error) => {
            }).finally(() => {
                this.setState({
                    isFetchingPopularShops: false
                })
            })
    }

    paginationPopularShops = (page) => {
        this.fetchPopularShops(page)
        this.setState({
            page: page - 1
        })
    }

    paginationShopType = (page) => {
        this.fetchShopByType(page)
        this.setState({
            page: page - 1
        })
    }

    render() {
        const { shopData, shops, isFetchingData, shopType, popularShops, page, pageSize, totalElement, isFetchingPopularShops } = this.state

        return (
            <Row>
                <Col span={24}>
                    {
                        shops ? (
                            <>
                                <Row style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                                    <BackTitleCompo label="Most Popular Brands" onClickRoute={CustomPath.loyalty} />
                                </Row>
                                {
                                    isFetchingPopularShops ? <Skeleton /> :
                                        <Row gutter={[16, 16]}>
                                            {
                                                popularShops?.content?.map((data, index) => {
                                                    return (
                                                        <Col key={index} lg={6} md={6} sm={8} xs={8}>
                                                            <Link to={`${CustomPath.loyalty_shop_detail}/${data.id}`} state={{ prevRoute: CustomPath.shops, stateData: shops, stateName: 'shops' }}>
                                                                <NJVCard cardpadding="12px" style={{ height: 190 }}>
                                                                    <Flex gap={20} align='center' vertical justify='center'>
                                                                        {
                                                                            data?.shopProfileUrl &&
                                                                            <Image
                                                                                src={data.shopProfileUrl}
                                                                                preview={false}
                                                                                style={{ cursor: 'pointer', objectFit: 'cover', borderRadius: '50%', width: 60, height: 60 }}
                                                                                alt="Shop Profile"
                                                                                fallback={ThumbnailImg}
                                                                                placeholder={<Image
                                                                                    preview={false}
                                                                                    style={{ cursor: 'pointer', objectFit: 'cover', borderRadius: '50%', width: 60, height: 60 }}
                                                                                    alt="Thumbnail"
                                                                                    src="https://d1jejw4ssai0l5.cloudfront.net/NinjaContentPics/Profile.png"
                                                                                    width={200}
                                                                                />}
                                                                            />
                                                                        }
                                                                        <Flex style={{ textAlign: 'center' }} vertical gap={10}>
                                                                            <span style={{ fontWeight: 600 }}>{data?.fullName}</span>
                                                                            <span>
                                                                                <Tag color='#2db7f5'>{data?.shopType}</Tag>
                                                                            </span>
                                                                        </Flex>
                                                                    </Flex>
                                                                </NJVCard>
                                                            </Link>
                                                        </Col>
                                                    )
                                                })
                                            }
                                            <Col span={24} style={{ marginTop: 20, display: 'flex', justifyContent: 'right' }}>
                                                <Pagination
                                                    showSizeChanger={false}
                                                    current={page}
                                                    defaultPageSize={pageSize}
                                                    total={totalElement}
                                                    onChange={this.paginationPopularShops}
                                                />
                                            </Col>
                                        </Row>
                                }
                            </>
                        ) : (
                            <>
                                <Row style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                                    <BackTitleCompo label={shopType?.label} onClickRoute={CustomPath.loyalty} />
                                </Row>
                                {
                                    isFetchingData ?
                                        <Skeleton />
                                        :
                                        <>
                                            {
                                                shopData?.content?.length > 0 ?
                                                    <Row gutter={[24, 24]}>
                                                        {
                                                            shopData?.content?.map((data, index) => {
                                                                return (
                                                                    <Col key={index} lg={6} md={6} sm={8} xs={8}>
                                                                        <Link to={`${CustomPath.loyalty_shop_detail}/${data.id}`} state={{ prevRoute: CustomPath.shops, stateData: shopType, stateName: 'shopType' }}>
                                                                            <NJVCard cardpadding="12px">
                                                                                <Flex gap={20} align='center' vertical justify='center'>
                                                                                    {
                                                                                        data?.shopProfileUrl &&
                                                                                        <Image
                                                                                            src={data.shopProfileUrl}
                                                                                            preview={false}
                                                                                            style={{ cursor: 'pointer', objectFit: 'cover', borderRadius: '50%', width: 60, height: 60 }}
                                                                                            alt="Shop Profile"
                                                                                            fallback={ThumbnailImg}
                                                                                        />
                                                                                    }
                                                                                    <span style={{ fontWeight: 600, marginBottom: 10 }}>{data?.fullName}</span>
                                                                                </Flex>
                                                                            </NJVCard>
                                                                        </Link>
                                                                    </Col>
                                                                )
                                                            })}
                                                        <Col span={24} style={{ marginTop: 20, display: 'flex', justifyContent: 'right' }}>
                                                            <Pagination
                                                                showSizeChanger={false}
                                                                current={page}
                                                                defaultPageSize={pageSize}
                                                                total={totalElement}
                                                                onChange={this.paginationShopType}
                                                            />
                                                        </Col>
                                                    </Row> : <Flex justify='center' align='center' style={{ marginTop: 80 }}>
                                                        <Image src={NoData} alt='no data' width={120} />
                                                    </Flex>
                                            }
                                        </>
                                }
                            </>
                        )
                    }
                </Col>
            </Row >
        )
    }
}

export default compose(withRouter)(ShopTypePage)

